import React, { useContext, useEffect, useState, useRef } from "react";
import config, { getParameterByName, merchantCode } from "../util";
import { Store } from "../Store";
import Chip from "@mui/material/Chip";
import axios from "axios";
import Slider from "react-slick";
import SearchBar from '../components/SearchBar'; 
import { addToOrder, clearOrder, removeFromOrder, listCategories,
  listProducts, } from "../actions";
import FmdGoodOutlinedIcon from '@mui/icons-material/FmdGoodOutlined';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  CircularProgress,
  Dialog,
  DialogTitle,
  Grid,
  ClickAwayListener,
  Slide,
  Fab,
  IconButton,
  MenuList,
  MenuItem,
  Zoom,
  Popper,
  Grow,
  Paper,

  AppBar,
  Toolbar,
  TextField,
  Typography,

  Switch,
  FormControlLabel,
  FormGroup,
  Tabs,
  Tab
} from "@material-ui/core";
import HomeIcon from '@mui/icons-material/Home';
import GradingIcon from '@mui/icons-material/Grading';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import FavoriteIcon from '@mui/icons-material/Favorite';
import RedeemIcon from '@mui/icons-material/Redeem';
import { useLocation, useHistory } from 'react-router-dom';
import PlaceIcon from '@mui/icons-material/Place';
import RestaurantMenuIcon from '@material-ui/icons/RestaurantMenu';
import AccountCircleIcon from '@material-ui/icons/AccountCircle'; // Add this import
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'; // Add this import
import ShoppingBasketIcon from "@material-ui/icons/ShoppingBasket";
import { useStyles } from "../styles";
import CartReview from "../components/Cart_Review";
import OrderCustomize from "../components/Order_Customize";
import CartButton from "../components/Cart_Button";
import BackButton from '../components/Back_Button';
import Categories from '../components/Categories';
import ProductList from '../components/Product_List';

import FeaturedSlider from '../components/FeaturedSlider'; // Add this import

import ReserveTable from './ReserveTable';
import SlidingPane from "react-sliding-pane";
import SignUp from './SignUp';
import "react-sliding-pane/dist/react-sliding-pane.css";
import ReviewScreen from "./ReviewScreen";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { useIntl } from "react-intl";
import onlineLogo from '../assets/image/matari-gold-logo.svg';
//import bgImg from '../assets/image/bg.jpg';
import SearchIcon from '@material-ui/icons/Search';
import { keyframes } from '@emotion/react';
import { styled } from '@mui/material/styles';

export default function OrderScreen(props) {
  const styles = useStyles();
    const history = useHistory();
  const { formatMessage: t, locale, setLocale } = useIntl();
  const { state, dispatch } = useContext(Store);
  const { categories, loading, error } = state.categoryList;
  let {customizeInWizard} = state;
  const [orderItem, setOrderItem] = useState(null);
  let pgSets = {customizeInWizard};
   let { promos } = state.promos;
  const splashScreens = promos.filter(pr => pr.useAt == 'ONLINE_BANNER');
  console.log(splashScreens);
  const {
    products,
    loading: loadingProducts,
    error: errorProducts,
  } = state.productList;
  const { orderItems = [], itemsCount = 0, totalPrice = 0, taxPrice = 0, orderType = '' } =
    state.order || {};
  const [quantity, setQuantity] = useState(1);
  const [selectedCat, setSelectedCat] = useState("");
  const[isReservePaneOpen, setReservePaneOpen]= useState(false);
  const [searchQuery, setSearchQuery] = useState(""); // Add state for search query
  const [isVegOnly, setIsVegOnly] = useState(false); // Uncomment this line
  //const [isVegOnly, setIsVegOnly] = useState(false);
  //dialogs state
    const [tabSel, setTabSel] = React.useState(0);
const [isOpen, setIsOpen] = useState(false);
  const [isCustomizeOpen, setIsCustomizeOpen] = useState(false);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [isCategoryMenuOpen, setIsCategoryMenuOpen] = useState(false);
  const anchorRef = React.useRef(null);
  const baseURL = config.baseURL;
  let {setting} = state.userSetting;
  let { userInfo } = state.userData;
  const themeColor = userInfo?.themeColor || '#ffbc01';  
  const themeTxtColor = userInfo?.themeTxtColor || '#000';  
 const customersInfo =sessionStorage.getItem("customerInfo")?JSON.parse(sessionStorage.getItem("customerInfo")):"";
  if(!setting){
    setting=JSON.parse(localStorage.getItem("userInfo"));
  }

    let userData =localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):null;
  // if (userData) {
  //   let body = document.getElementsByTagName("body");
  //   //body[0].style.backgroundColor = setting.color_tirnary;
  //   setTimeout(() => {
  //     let textcolor = document.getElementById("title1");
  //     textcolor.style.color = userData.color_primary;
  //   }, 10);
  // }
  const isMobile = true;
  // Add state for profile menu
  const [profileMenuAnchor, setProfileMenuAnchor] = useState(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [showSearchInput, setShowSearchInput] = useState(false);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const [showPickupAddress, setShowPickupAddress] = useState(false);

  const [isPaneOpen, setIsPaneOpen] = useState(false);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const searchIconRef = useRef(null);
  // const arrowRef = useRef(null);
  // // Responsive popover width
  // const [popoverWidth, setPopoverWidth] = useState(340);


  useEffect(() => {
     listCategories(dispatch);
     listProducts(dispatch);
  }, []);

  const getCurrentAddrss = () => {

    //https://dev.virtualearth.net/REST/v1/Locations/15.465810,75.005360?o=json&key=ArW_TkF5xKfdKeIe4Ac-IQaAI7Mm3FLkRbPaj0g5EqEvF01MqV5JMR-ABy2BxrPd
  }

  const closeHandler = () => {
    setIsCustomizeOpen(false);
    setIsCartOpen(false);
    setIsOpen(false);
  };

  const vegHandler = () => {
    setIsVegOnly(!isVegOnly);
  };

  const categoryClickHandler = (cat) => {
    console.log(cat);
    setSelectedCat(cat);
    setIsCategoryMenuOpen(false);
  };

  const addToOrderHandler = (customInstr) => {
    //Set price if variety price availabe
    let varName = Object.keys(orderItem.sub_pro.variety);
    orderItem.price = varName.length
        ? parseFloat(orderItem.sub_pro.variety[varName[0]])
        : orderItem.price;

    customInstr.length && orderItem.sub_pro.cookInstructions.push(customInstr);
    console.log(orderItem);
    
    addToOrder(dispatch, { ...orderItem, quantity });
    setIsCustomizeOpen(false);
    setOrderItem(null);
    let isEditOrdItem = orderItems.filter(om => om.id == orderItem.id).length;
    isEditOrdItem && setIsCartOpen(true);
  };

  const productClickHandler = (p, isEditOrder) => {
    if (!isEditOrder) {
      p['sub_pro'] = {};
      p.sub_pro['addons'] = [];
      p.sub_pro['variety'] = {};
      p.sub_pro['cookInstructions'] = [];
    }
    setOrderItem(p);
    setIsCartOpen(false);
    setIsCustomizeOpen(!isCustomizeOpen);
  };

  const removeOrderItm = () => {
    setIsCustomizeOpen(false);
    setOrderItem(null);
    removeFromOrder(dispatch, orderItem);
  };

  const procedToCheckoutHandler = () => {
    let loginData = sessionStorage.getItem('customerInfo');
    loginData = JSON.parse(loginData);
    if (loginData !== null) {
      props.history.push("/payment?" + window.location.href.split('?')[1]);
    } else {
     // setOpenSign(true);
      setIsCartOpen(false);
    }
  };
const goto =(subpath) =>{
      history.push('/'+subpath+'?' + window.location.href.split('?')[1]);
  }
  const previewOrderHandler = () => {
    props.history.push("/payment?" + window.location.href.split("?")[1]);
  };

  const handleCart = (cartItems) => {
    console.log("Cart");
    if (cartItems == 0) return;
    setIsCartOpen(true);
  };

  const imageOnErrorHandler = (event) => {
    event.currentTarget.src = "./images/blank.jpg";
  };

  const handleBack = () => {
    if (isCartOpen || isCustomizeOpen) {
      setIsCartOpen(false);
      setIsCustomizeOpen(false);
    } else {
      props.history.push(`/choose?` + window.location.href.split("?")[1]);
    }
  };

  const handleToggle = () => {
    setIsCategoryMenuOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setIsCategoryMenuOpen(false);
  };

  // Add handler for profile menu
  const handleProfileMenuToggle = () => {
   // setProfileMenuOpen((prev) => !prev);
  };

  const handleProfileMenuClose = (event) => {
    // if (profileRef.current && profileRef.current.contains(event.target)) {
    //   return;
    // }
   // setProfileMenuOpen(false);
  };

  const filteredProducts = products ? products.filter(product => 
    (searchQuery === "" || product.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
    (product.description && product.description.toLowerCase().includes(searchQuery.toLowerCase()))) &&
    (!isVegOnly || (isVegOnly && product.cat_type.toLowerCase() === 'veg'))
  ) : [];

  const getImageUrl = (imagePath) => {
    if (!imagePath) return "./images/blank.jpg";
    if (imagePath.startsWith('http')) return imagePath;
    return `${baseURL}${imagePath.startsWith('/') ? '' : '/'}${imagePath}`;
  };

  // get address or coords from SelectPaymentScreen
  const query = new URLSearchParams(props.location.search);
  const addressParam = query.get('address') || userData?.address;
  const latParam = query.get('lat');
  const lngParam = query.get('lng');
  const [displayAddress, setDisplayAddress] = useState("");
  // determine label based on orderType
  const isPickup = orderType?.toLowerCase().includes('pick');
  const headerLabel = isPickup ? 'Pickup at: ' : 'Delivery at: ';
  // reverse geocode if coords provided
  useEffect(() => {
    
    if (!isPickup && (latParam && lngParam)) {
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latParam}&lon=${lngParam}&format=json`)
        .then(res => res.json())
        .then(data => {
          if (data.display_name) setDisplayAddress(data.display_name);
        })
        .catch(() => setDisplayAddress(addressParam));
    }
    if (isPickup && userData.location) {
      fetch(`https://nominatim.openstreetmap.org/reverse?lat=${userData.location.coordinates[0]}&lon=${userData.location.coordinates[1]}&format=json`)
        .then(res => res.json())
        .then(data => {
          console.log(data);
          if (data.display_name) setDisplayAddress(data.display_name);
        })
        .catch(() => setDisplayAddress(addressParam));
    }
  }, []);

  const handleTabChange = (event, newValue) => {
    setTabSel(newValue);
  }

  return (
      <Box
      className={styles.root}
      style={{ padding: "0px!important", backgroundColor: setting.themeColor }} 
      id={"order-root"}
     /* Chrome, Safari, Opera*/
      >
    <div style={{height:"50px",width:"100%",display:"flex",justifyContent:"space-between",padding:"5px", fontFamily:setting.themeSecondaryFontFam}}>
      <div style={{width:"120px",marginLeft:"5px", color:"#fff", marginTop:"0px", display: 'flex', justifyContent: 'flex-start', alignItems: 'center'}}>
      <span style={{marginLeft: '10px',color:"#fff"}}>{`Welcome! ${customersInfo?.customer?.firstName ||"Guest"}`}</span>
      
    </div>
    <div style={{paddingTop:"1px",maxWidth:"150px", color: "#FFF",  fontWeight: 500, fontFamily:setting.themeSecondaryFontFam, marginRight:"10px"}}>
      
      <FmdGoodOutlinedIcon
       style={{ cursor: 'pointer', fontSize: 29, marginRight:"10px" }} 
        onClick={(e) => {
          setSearchAnchorEl(e.currentTarget);
          //setShowSearchInput(true);
          setShowPickupAddress(true);
        }} 
      />

      <SearchIcon 
        style={{ cursor: 'pointer', fontSize: 32, paddingTop:'4px' }} 
        onClick={(e) => {
          setSearchAnchorEl(e.currentTarget);
          setShowSearchInput(true);
        }} 
        ref={searchIconRef}
      />
      
    </div>
  
    </div>
      <div className={styles.promo} style={{padding:"0px 10px", maxHeight:"200px",overflow:"hidden"}}>
        <Slider {...settings} autoplay={true} autoplaySpeed={2000}>

        {splashScreens.map(splash => (<div >
            <img style={{borderRadius:"10px"}} src={splash?.url} className={styles.promoImg} />
          </div>))
        }  
        </Slider>
      </div>

          <Typography 
              component="h2" 
              style={{ 
                padding:"0px 10px",
                textAlign: 'left',
                fontWeight: '300',
                color: userData.themeTxtColor,
                fontSize: isMobile ? '1.1rem' : '1.5rem',
              }}
            >
              {(selectedCat && selectedCat.name) || t({ id: "explore_menu" })}
            </Typography>
      {/* Fixed header section */}

      <Box style={{ 
        overflowX:"hidden",
        height: splashScreens.length?"calc(100vh - 310px)":"calc(100vh - 150px)",
        marginTop: "5px",
        overflow: 'auto',
        msOverflowStyle: "none", 
        scrollbarWidth: "none"  
      }}>
        
        
        {/* ProductList - direct without extra wrapper */}
        <ProductList 
          items={filteredProducts} 
          baseURL={baseURL}
          pgSets={pgSets}
          userData= {userData}
          imageOnErrorHandler={imageOnErrorHandler}
          productClickHandler={productClickHandler}
          categories={categories ? categories : []}
          selectedCat={selectedCat}
          style={{ backgroundColor: themeColor }}
          t={t}
        />
      </Box>

      <Dialog 
        onClose={closeHandler}
        aria-labelledby="max-width-dialog-title"
        open={isCartOpen || isCustomizeOpen}
        fullWidth={true}
        maxWidth={'xl'}
      >
        {isCustomizeOpen && <OrderCustomize 
          orderItem={orderItem} 
          setOrderItem={setOrderItem}
          baseURL={baseURL}
          imageOnErrorHandler={imageOnErrorHandler}
          quantity={quantity}
          categories={categories}
          setQuantity={setQuantity}
          orderItems={orderItems}
          items={products ? products : []}
          setIsCustomizeOpen={setIsCustomizeOpen}
          addToOrderHandler={addToOrderHandler}
          removeOrderItm={removeOrderItm}
          t={t}
           userData= {userData}
          style={{ backgroundColor:userData.themeTxtColor }}
        />}

        {isCartOpen && <CartReview 
          t={t}  
          orderItems={orderItems}
          setIsCartOpen={setIsCartOpen}
          productClickHandler={productClickHandler}
          categories={categories ? categories : []}
          procedToCheckoutHandler={procedToCheckoutHandler}
          style={{ backgroundColor: themeColor }}
        />}

       
      </Dialog>

      {/* Floating Category Button - Enhanced */}
      <Zoom in={true}>
        <Fab 
          aria-label="categories"
          style={{ 
            position: 'fixed', 
            bottom: isMobile ? '80px' : '30px', 
            right: isMobile ? '20px' : '30px', 
            backgroundColor: themeColor, 
            color: themeTxtColor, 
            zIndex: 1000,
            boxShadow: '0 4px 14px rgba(0,0,0,0.25)'    
          }}
          onClick={handleToggle}
          ref={anchorRef}
        >
          <RestaurantMenuIcon />
        </Fab>
      </Zoom>

      <Popper open={isCategoryMenuOpen} anchorEl={anchorRef.current} role={undefined} transition disablePortal style={{overflow:'auto',maxHeight:"400px"}}>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList autoFocusItem={isCategoryMenuOpen} id="menu-list-grow">
                  {categories && categories.map((category) => (
                    <MenuItem 
                      key={category.id} 
                      onClick={() => categoryClickHandler(category)}
                      style={{ display: 'flex', alignItems: 'center' }}
                    >
                      <div style={{ 
                        width: '40px', 
                        height: '40px', 
                        borderRadius: '50%', 
                        overflow: 'hidden', 
                        marginRight: '10px' 
                      }}>
                        <img 
                          src={getImageUrl(category.image)} 
                          alt={category.name} 
                          onError={imageOnErrorHandler} 
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                        />
                      </div>
                      {category.name}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
       <Popper
        open={showSearchInput || showPickupAddress}
        anchorEl={searchAnchorEl}
        placement="bottom-end"
        transition
        style={{ zIndex: 99999 }}
      >
        {({ TransitionProps }) => (
          <Grow {...TransitionProps} style={{ transformOrigin: 'center top', transition: 'all 0.18s cubic-bezier(.4,2,.6,1)' }}>
            <div style={{ position: 'relative', width: '100%', maxWidth: '98vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Paper style={{ 
                padding: '10px',
                background: setting.themeColor,
                border: `2px solid ${setting.themeTxtColor}`,
                borderRadius: '10px',
                margin: '8px 0 8px 0',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                transition: 'all 0.18s cubic-bezier(.4,2,.6,1)',
                minWidth: 0,
                height: '48px',
                width: '100%',
                maxWidth: 320,
                color : setting.themeTxtColor,
                fontFamily: setting.themeSecondaryFontFam
              }}>
                <ClickAwayListener onClickAway={() => {
                  setShowSearchInput(false);
                  setShowPickupAddress(false);
                  setSearchAnchorEl(null);
                }}>
                  {showPickupAddress?<div> 
                    <span style={{color:"#fff"}}>Our address: </span> 
                   {setting.address|| 'Not available'}</div>:


                  <form style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', margin: 0, padding: 0 }} onSubmit={e => { e.preventDefault(); }}>
                    <input
                      autoFocus
                      type="text"
                      value={searchQuery}
                      onChange={e => setSearchQuery(e.target.value)}
                      placeholder="Search menu items..."
                      style={{
                        width: '100%',
                        maxWidth: 250,

                        fontFamily: setting.themeSecondaryFontFam,
                        outline: 'none',
                        fontSize: '0.9em',
                        color: '#fff',
                        border: 'none',
                        height: '35px',
                        fontWeight: 400,
                        letterSpacing: '0.01em',
                        fontFamily: 'inherit',
                       margin:"10px",
                        backgroundColor: 'transparent',
                        transition: 'border 0.18s',
                        '::placeholder': {
                          color: '#fff',
                          opacity: 1,
                        },
                      }}
                    />
                  </form>}
                </ClickAwayListener>
              </Paper>
            </div>
          </Grow>
        )}
      </Popper>
          <Tabs 
        style={{
          backgroundColor: setting.themeTxtColor,
          borderTop: "2px solid " + setting.themeColor,
          padding:"10px"
        }} 
        className="footer-tab" 
        value={tabSel} 
        onChange={handleTabChange} 
        aria-label="tabs footer"
      >
        <Tab 
          style={{
            background: tabSel==0 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==0 ? '#fff' : ""
          }} 
          onClick={() => goto('order')} 
          icon={<HomeIcon />}  
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==1 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==1 ? '#fff' : "",
            position: 'relative',
          }} 
          onClick={() => goto('cart')} 
          icon={
            <Box sx={{ position: 'relative', padding: '4px' }}>
              <ShoppingCartIcon />
             
               {state.order.itemsCount > 0 && (
                          <span className={"badge"} style={{background:'red',color:'#fff'}}>
                            {state.order.itemsCount}
                          </span>
                        )}
             
            </Box>
          }
          label="" 
        />
        <Tab 
          style={{
            background: tabSel==2 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==2 ? '#fff' : ""
          }} 
          onClick={() => {
            setTabSel(2);
            goto('favourites');
          }} 
          icon={<FavoriteIcon />} 
          label="" 
        />
        <Tab
          style={{
            background: tabSel==3 ? setting.themeColor : "",
            borderRadius: "24px",
            color: tabSel==3 ? '#fff' : "",
            position: 'relative'
          }}
          onClick={() => {
            history.push('/profile?' + window.location.href.split("?")[1]);
          }}
          icon={<AccountCircleIcon />}
          label="" 
        />
      </Tabs>
    </Box>
  );
}
